import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Leaf, ShieldCheck, ShoppingCart, Truck, CreditCard, User, MapPin, ChevronLeft, ChevronRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import { BACKEND_URL } from '../config';

export default function MarketplaceInfoPage() {
  const navigate = useNavigate();
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [orderForm, setOrderForm] = useState({
    name: '', phone: '', email: '', address: '', city: '', state: '', pincode: ''
  });
  const [orderStatus, setOrderStatus] = useState(null);

  const RAZORPAY_PAYMENT_LINK = "https://rzp.io/rzp/A0DEYp36";

  const productImages = [
    {
      url: "https://customer-assets-cm19k8pv.emergentagent.net/job_54605008-3eaf-4fe2-bcea-45537e56bd17/artifacts/vmftk4ek_IMG_7600.jpeg",
      alt: "BoAI Desi Ghee - Front View"
    },
    {
      url: "https://customer-assets-cm19k8pv.emergentagent.net/job_54605008-3eaf-4fe2-bcea-45537e56bd17/artifacts/h60lnrif_IMG_7599.jpeg",
      alt: "BoAI Desi Ghee - Back View (Nutritional Info)"
    }
  ];

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % productImages.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + productImages.length) % productImages.length);
  };

  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    setOrderStatus('loading');

    try {
      const response = await fetch(`${BACKEND_URL}/api/orders/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_name: 'BoAI Desi Ghee - Bilona Method',
          quantity: 1,
          mrp: 2100,
          offer_price: 1500,
          customer: orderForm
        })
      });

      if (!response.ok) throw new Error('Failed to create order');
      
      const data = await response.json();
      
      // Redirect to Razorpay payment with order ID
      window.location.href = `${RAZORPAY_PAYMENT_LINK}?prefill[name]=${encodeURIComponent(orderForm.name)}&prefill[email]=${encodeURIComponent(orderForm.email)}&prefill[contact]=${encodeURIComponent(orderForm.phone)}&notes[order_id]=${data.order_id}`;
      
    } catch (err) {
      console.error('Order error:', err);
      setOrderStatus('error');
    }
  };

  const validateForm = () => {
    return orderForm.name && orderForm.phone && orderForm.email && 
           orderForm.address && orderForm.city && orderForm.state && orderForm.pincode;
  };

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-content">

        {/* Desi Ghee Product - Order Now */}
        <section className="ghee-product-section" data-testid="ghee-product-section">
          <div className="container">
            <div className="ghee-product-card">
              <div className="ghee-product-image">
                <div className="image-carousel">
                  <button className="carousel-btn prev" onClick={prevImage} aria-label="Previous image">
                    <ChevronLeft size={24} />
                  </button>
                  <img 
                    src={productImages[currentImage].url}
                    alt={productImages[currentImage].alt}
                  />
                  <button className="carousel-btn next" onClick={nextImage} aria-label="Next image">
                    <ChevronRight size={24} />
                  </button>
                </div>
                <div className="carousel-dots">
                  {productImages.map((_, index) => (
                    <button 
                      key={index}
                      className={`carousel-dot ${index === currentImage ? 'active' : ''}`}
                      onClick={() => setCurrentImage(index)}
                      aria-label={`View image ${index + 1}`}
                    />
                  ))}
                </div>
                <div className="ghee-discount-badge">29% OFF</div>
              </div>
              
              <div className="ghee-product-details">
                <div className="ghee-brand-badge"><Leaf size={14} /> BoAI Premium</div>
                <h1>Desi Ghee</h1>
                <h2 className="ghee-subtitle">• BILONA METHOD •</h2>
                <p className="ghee-tagline">Purity in Every Spoon</p>
                
                <div className="ghee-features">
                  <span className="ghee-feature">A2 Pure</span>
                  <span className="ghee-feature">Lab Tested</span>
                  <span className="ghee-feature">Bilona Method</span>
                  <span className="ghee-feature">Rich in Nutrients</span>
                  <span className="ghee-feature">No Additives</span>
                  <span className="ghee-feature">Authentic Aroma</span>
                </div>

                <div className="ghee-quantity">
                  <span className="quantity-label">Net Quantity:</span>
                  <span className="quantity-value">1 Litre</span>
                </div>

                <div className="ghee-pricing">
                  <span className="ghee-mrp">MRP: <s>₹2,100</s></span>
                  <span className="ghee-offer-price">₹1,500</span>
                  <span className="ghee-save">You Save ₹600!</span>
                </div>

                <div className="ghee-benefits-strip">
                  <div className="benefit-item"><Truck size={16} /> Free Delivery</div>
                  <div className="benefit-item"><ShieldCheck size={16} /> 100% Authentic</div>
                  <div className="benefit-item"><CreditCard size={16} /> Secure Payment</div>
                </div>

                <button 
                  className="ghee-order-btn"
                  onClick={() => setShowOrderForm(true)}
                  data-testid="order-ghee-btn"
                >
                  <ShoppingCart size={20} /> Order Now @ ₹1,500
                </button>
                
                <p className="delivery-note">🚚 Delivery in 2-5 Business Days</p>
              </div>
            </div>
          </div>
        </section>

        {/* Order Form Modal */}
        {showOrderForm && (
          <div className="order-modal-overlay" onClick={() => setShowOrderForm(false)}>
            <div className="order-modal" onClick={e => e.stopPropagation()}>
              <div className="order-modal-header">
                <h3><ShoppingCart size={20} /> Complete Your Order</h3>
                <button className="modal-close" onClick={() => setShowOrderForm(false)}>×</button>
              </div>

              <div className="order-product-summary">
                <div className="order-product-info">
                  <strong>BoAI Desi Ghee - Bilona Method</strong>
                  <span>1 Litre</span>
                </div>
                <div className="order-product-price">₹1,500</div>
              </div>

              <form onSubmit={handleOrderSubmit} className="order-form">
                <div className="form-section-title"><User size={16} /> Personal Details</div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input 
                      type="text" 
                      value={orderForm.name}
                      onChange={e => setOrderForm({...orderForm, name: e.target.value})}
                      placeholder="Enter your name"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input 
                      type="tel" 
                      value={orderForm.phone}
                      onChange={e => setOrderForm({...orderForm, phone: e.target.value})}
                      placeholder="10-digit mobile"
                      pattern="[0-9]{10}"
                      required
                    />
                  </div>
                </div>

                <div className="form-group full-width">
                  <label>Email Address *</label>
                  <input 
                    type="email" 
                    value={orderForm.email}
                    onChange={e => setOrderForm({...orderForm, email: e.target.value})}
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div className="form-section-title"><MapPin size={16} /> Delivery Address</div>

                <div className="form-group full-width">
                  <label>Complete Address *</label>
                  <input 
                    type="text" 
                    value={orderForm.address}
                    onChange={e => setOrderForm({...orderForm, address: e.target.value})}
                    placeholder="House/Flat No., Street, Landmark"
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>City *</label>
                    <input 
                      type="text" 
                      value={orderForm.city}
                      onChange={e => setOrderForm({...orderForm, city: e.target.value})}
                      placeholder="City"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>State *</label>
                    <input 
                      type="text" 
                      value={orderForm.state}
                      onChange={e => setOrderForm({...orderForm, state: e.target.value})}
                      placeholder="State"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Pincode *</label>
                    <input 
                      type="text" 
                      value={orderForm.pincode}
                      onChange={e => setOrderForm({...orderForm, pincode: e.target.value})}
                      placeholder="6-digit"
                      pattern="[0-9]{6}"
                      required
                    />
                  </div>
                </div>

                <div className="order-total-section">
                  <div className="order-total-row"><span>Subtotal</span><span>₹1,500</span></div>
                  <div className="order-total-row"><span>Delivery</span><span className="free-delivery">FREE</span></div>
                  <div className="order-total-row total"><span>Total</span><span>₹1,500</span></div>
                </div>

                {orderStatus === 'error' && (
                  <div className="order-error">Something went wrong. Please try again.</div>
                )}

                <button 
                  type="submit" 
                  className="order-pay-btn"
                  disabled={!validateForm() || orderStatus === 'loading'}
                >
                  {orderStatus === 'loading' ? 'Processing...' : (
                    <><CreditCard size={18} /> Proceed to Pay ₹1,500</>
                  )}
                </button>

                <p className="payment-secure-note">
                  <ShieldCheck size={14} /> Secure payment via Razorpay
                </p>
              </form>
            </div>
          </div>
        )}

        {/* More Products Coming Soon */}
        <section className="marketplace-section">
          <div className="container">
            <div className="marketplace-showcase">
              <div className="marketplace-header">
                <div className="marketplace-badge">MORE PRODUCTS COMING SOON</div>
                <h2>BoAI Marketplace</h2>
                <h3 className="hindi-text">BoAI बाज़ार</h3>
                <p className="marketplace-tagline">Your One-Stop Agricultural E-Commerce Platform</p>
              </div>

              <div className="marketplace-grid">
                <div className="marketplace-card seeds-card">
                  <div className="marketplace-icon">🌱</div>
                  <h4>Seeds & Saplings</h4>
                  <p className="hindi-small">बीज और पौधे</p>
                  <ul className="marketplace-items">
                    <li>Premium quality seeds</li><li>Hybrid varieties</li><li>Organic options</li>
                  </ul>
                </div>
                <div className="marketplace-card pesticides-card">
                  <div className="marketplace-icon">🐛</div>
                  <h4>Pesticides</h4>
                  <p className="hindi-small">कीटनाशक</p>
                  <ul className="marketplace-items">
                    <li>Certified products</li><li>Organic options</li><li>Usage guidelines</li>
                  </ul>
                </div>
                <div className="marketplace-card fertilizers-card">
                  <div className="marketplace-icon">💧</div>
                  <h4>Fertilizers</h4>
                  <p className="hindi-small">उर्वरक</p>
                  <ul className="marketplace-items">
                    <li>Organic fertilizers</li><li>NPK varieties</li><li>Soil enhancers</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
